import { render, staticRenderFns } from "./Notifiche.vue?vue&type=template&id=4ae322bb&scoped=true&"
import script from "./Notifiche.vue?vue&type=script&lang=js&"
export * from "./Notifiche.vue?vue&type=script&lang=js&"
import style0 from "./Notifiche.vue?vue&type=style&index=0&id=4ae322bb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae322bb",
  null
  
)

component.options.__file = "Notifiche.vue"
export default component.exports